import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom, IconButton, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '16px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        [theme.breakpoints.down('sm')]: {
            minWidth: '90vw',
            maxWidth: '90vw',
        },
    },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    color: '#ffffff',
    padding: '20px 24px',
    fontWeight: 700,
    fontSize: '1.25rem',
    fontFamily: "'DM Sans', sans-serif",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: '24px !important',
    paddingTop: '28px !important',
    background: '#f8f9fa',
    color: '#000000',
    '& > *:first-child': {
        marginTop: '0 !important',
    },
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'linear-gradient(180deg, #1a73e8 0%, #00bfa5 100%)',
        borderRadius: '10px',
        '&:hover': {
            background: 'linear-gradient(180deg, #1557b0 0%, #009688 100%)',
        },
    },
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
    padding: '16px 24px',
    background: '#f8f9fa',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    gap: '12px',
}));

const SaveButton = styled(Button)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    color: '#ffffff',
    fontSize: '1rem',
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(26, 115, 232, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
        boxShadow: '0 6px 20px rgba(26, 115, 232, 0.4)',
        transform: 'translateY(-2px)',
    },
}));

const CancelButton = styled(Button)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    color: '#5f6368',
    fontSize: '1rem',
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: 'rgba(0, 0, 0, 0.04)',
        borderColor: 'rgba(0, 0, 0, 0.2)',
    },
}));

export default function CustomAddModal(props) {
    const { handleClose, title, onSubmitConfirm, open, saveLabel = 'Add', maxWidth = "sm" } = props;
    return (
        <StyledDialog
            open={open}
            fullWidth
            maxWidth={maxWidth}
            TransitionComponent={Zoom}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <StyledDialogTitle id="alert-dialog-title">
                <span>{title}</span>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        color: '#ffffff',
                        '&:hover': {
                            background: 'rgba(255, 255, 255, 0.1)',
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </StyledDialogTitle>
            <StyledDialogContent>
                {props.children}
            </StyledDialogContent>
            <StyledDialogActions>
                <CancelButton onClick={handleClose}>
                    Cancel
                </CancelButton>
                <SaveButton onClick={onSubmitConfirm} startIcon={<SaveIcon />}>
                    {saveLabel}
                </SaveButton>
            </StyledDialogActions>
        </StyledDialog>
    );
}